import { act, useCallback, useEffect, useState } from "react";
import useAdFunctions from "./useAdFunctions.hook";
import AdModel from "../../domain/models/ad.model";


const useAdGeneralConf = () => {
    const { getAllAds, createAd, updateAd, deleteAd, uploadAdImage } = useAdFunctions();
    const [isLoadingData, setIsLoadingData] = useState(true);
    const [ads, setAds] = useState<AdModel[]>([]);

    const fetchAds = useCallback(async () => {
        setIsLoadingData(true);
        setAds(await getAllAds());
        setIsLoadingData(false);
    }, [getAllAds]);


    const deleteAdById = useCallback(async (id: number) => {
        setIsLoadingData(true);
        await deleteAd(id);
        await fetchAds();
        setIsLoadingData(false);
    }, [deleteAd, fetchAds]);

    const createAdHandler = useCallback(async (ad: AdModel) => {
        setIsLoadingData(true);
        await createAd(ad);
        await fetchAds();
        setIsLoadingData(false);
    }, [createAd, fetchAds]);

    const updateAdHandler = useCallback(async (ad: AdModel) => {
        setIsLoadingData(true);
        await updateAd(ad);
        await fetchAds();
        setIsLoadingData(false);
    }, [updateAd, fetchAds]);

    const uploadAdImageHandler = useCallback(async (file: File) => {
        setIsLoadingData(true);
        const response = await uploadAdImage(file);
        setIsLoadingData(false);
        return response;
    }, [uploadAdImage]);
    

    return {
        loaders: {
            isLoadingData,
        },
        data: {
            ads,
        },
        actions: {
            fetchAds,
            deleteAdById,
            createAdHandler,
            updateAdHandler,
            uploadAdImageHandler,
        }
    }
}

export default useAdGeneralConf;